var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87896 3.59719C4.52541 3.24364 3.9522 3.24364 3.59866 3.59719C3.24511 3.95074 3.24511 4.52395 3.59866 4.87749L8.71989 9.99873L3.59872 15.1199C3.24518 15.4734 3.24518 16.0467 3.59872 16.4002C3.95227 16.7538 4.52548 16.7538 4.87902 16.4002L10.0002 11.279L15.1214 16.4002C15.4749 16.7537 16.0481 16.7538 16.4017 16.4002C16.7552 16.0467 16.7552 15.4734 16.4017 15.1199L11.2805 9.99873L16.4017 4.87749C16.7553 4.52395 16.7553 3.95074 16.4017 3.59719C16.0482 3.24365 15.475 3.24365 15.1214 3.59719L10.0002 8.71843L4.87896 3.59719Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/closeModal.9ed55b75502cc95fd097d471da5382a8.svg";
export { ForwardRef as ReactComponent };